<template>
  <div class="about-content">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search v-model="searchContent" right-icon="" shape="round" placeholder="搜索内容"
                    @search="onCourseSearchEnter"
                    :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search"/>
          </template>
        </van-search>
      </form>
    </div>
    <div class="flex-div">
      <div class="flex-item" @click="handleClickFlex('technique')">
        <span>{{ curTechnique >= 0 ? techniqueArr[curTechnique].technologyName : '新技术类型' }}</span>
        <img src="@/assets/images/cartojourney/img47.png" class="icon-up" alt="">
      </div>
      <div class="flex-item" @click="handleClickFlex('actType')">
        <span>{{ curAct >= 0 ? actArr[curAct].value : '学术活动类型' }}</span>
        <img src="@/assets/images/cartojourney/img47.png" class="icon-up" alt="">
      </div>
      <div class="filter-fixed" v-show="showFilter">
        <div class="filter-con">
          <div class="filter-nav">
            <div class="title" v-if="flexType === 'technique'">新技术类型</div>
            <div class="title" v-else-if="flexType === 'actType'">学术活动类型</div>
            <div class="cons">
              <template v-if="flexType === 'technique'">
                <div v-for="(item, index) in techniqueArr" :key="index" class="cons-title"
                     :class="{ cur: index === curTechnique }" @click="handleTechnique(index)">
                  {{ item.technologyName }}
                </div>
              </template>
              <template v-else-if="flexType === 'actType'">
                <div v-for="(item, index) in actArr" :key="index" class="cons-title"
                     :class="{ cur: index === curAct }" @click="handleAct(index)">
                  {{ item.value }}
                </div>
              </template>
            </div>
          </div>
          <div class="fixed-btn">
            <div class="cancel-btn btn-txt" @click="onRepeat">重 置</div>
            <div class="submit-btn btn-txt" @click="onConfirm">确 认</div>
          </div>
        </div>
      </div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="con-list">
      <div class="con-item" v-for="(item, index) in searchList" :key="index">
        <img src="@/assets/images/cartojourney/img16.png" class="con-cover" alt=""/>
        <div class="con-txt">
          <div class="txt-title">{{ item.actName }}</div>
          <div class="txt-tag">{{ item.province }}{{ item.city }} {{ item.actStartDate ? item.actStartDate : '' }}
            {{ item.actTypeName }}
          </div>
        </div>
        <div class="action-btn cancel-btn" v-if="isCheck(item)" @click="handleCancel(item)">取消报名</div>
        <div class="action-btn sign-btn" v-else @click="handleSign(item)">报名</div>
      </div>
    </van-list>
  </div>
</template>
<script>
import {activityList, customizedChangeActivity, technologyListAll} from '@/api/cartoJourney.js'
import withRouteTracking from '@/utils/withRouteTracking'
import {debounce} from '@/utils/util.js'
import {dataDictionary} from '@/api/api'
import {deleteCustomizedActivity, journeyActivity} from '../../api/cartoJourney'
import {handleTraceSearchLog} from '../../utils/trace'

const UserProfile = {
  data() {
    return {
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      type: '1',
      load: false,
      searchList: [],
      showFilter: false,
      techniqueArr: [],
      curTechnique: -1,
      flexType: '',
      actArr: [],
      curAct: -1,
      customizedCode: '',
      customizedMultiCode: '',
      selectedList: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isCheck() {
      return (item) => {
        const open = this.selectedList.find(a => item.seepCode === a.seepCode)
        if (open) {
          this.$set(item, 'signId', open.id)
        }
        return open
      }
    }
  },
  async mounted() {
    const {
      customizedCode,
      customizedMultiCode
    } = this.$route.query
    this.customizedCode = customizedCode
    this.customizedMultiCode = customizedMultiCode
    await this.handleGetTechniqueList()
  },
  methods: {
    async getJourneyActivity() {
      let res
      if (this.customizedCode) {
        res = await journeyActivity('1', this.customizedCode)
      } else if (this.customizedMultiCode) {
        res = await journeyActivity('2', this.customizedMultiCode)
      }
      if (res.code === 0) {
        this.selectedList = res.data
      }
    },
    handleGetTechniqueList() {
      technologyListAll().then(res => {
        if (res.code === 0) {
          let newArr = [{technologyName: '全部'}]
          this.techniqueArr = newArr.concat(res.data)
        }
      })
      dataDictionary({
        typeCode: 'ACTIVITY_TYPE',
        dataStatus: 1,
      }).then((res) => {
        if (res.code === 0) {
          let newArr = [{value: '全部', code: ''}]
          this.actArr = newArr.concat(res.data)
        }
      })
    },
    handleClickFlex(type) {
      this.showFilter = !this.showFilter
      if (!this.showFilter) return
      this.flexType = type
    },
    onConfirm() {
      this.showFilter = false
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
    },
    onRepeat() {
      if (this.flexType === 'technique') {
        this.curTechnique = -1
      }
      if (this.flexType === 'actType') {
        this.curAct = -1
      }
    },
    handleAct(num) {
      this.curAct = this.curAct === num ? -1 : num
    },
    handleTechnique(num) {
      this.curTechnique = this.curTechnique === num ? -1 : num
    },
    onCourseSearchEnter: debounce(function (e) {
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      handleTraceSearchLog({
        'userId': this.userInfo.id,
        'searchContent': this.searchContent,
        'sessionId': localStorage.getItem('sessionId'),
        'type': 10,
        'entrance': 56,
      })
      this.onLoad()
      return false
    }, 500),
    async onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      let parmas = {
        userId: this.userInfo.id,
        keyword: this.searchContent,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        multiCode: this.customizedMultiCode,
      }
      if (this.curTechnique > 0) {
        parmas.actFrom = this.techniqueArr[this.curTechnique].technologyName
      }
      if (this.curAct > 0) {
        parmas.actType = this.actArr[this.curAct].code
      }
      await this.getJourneyActivity()
      const res = await activityList(parmas)
      this.load = false
      if (res.data.list.length < this.pageSize) {
        this.finished = true
      }
      this.searchList = this.searchList.concat(res.data.list)
      // 加载状态结束
      this.loading = false
      if (this.searchList.length <= 0) {
        this.isSearch = true
      } else {
        this.isSearch = false
      }
      this.pageNum++
    },

    clearSearchValue(e) {
      this.onCourseSearchEnter()
    },

    /*
     * 报名
     */
    async handleSign(item) {
      this.selectedList.push(item)
      let params = {
        'customizedId': this.customizedCode,
        'activitys': this.selectedList.map(res => {
          let item = {
            seepCode: res.seepCode,
            actName: res.actName,
            province: res.province,
            city: res.city,
            actStartDate: res.actStartDate,
            actEndDate: res.actEndDate,
            actType: res.actType
          }
          return item
        })
      }
      await customizedChangeActivity(params)
      this.$toast('已报名，记得返回推送哦')
      await this.getJourneyActivity()
    },

    /*
     * 取消报名
     */
    async handleCancel(item) {
      const res = await deleteCustomizedActivity(item.signId)
      if (res.code === 0) {
        await this.getJourneyActivity()
        this.$toast('已取消')
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.about-content {
  min-height: 100vh;
  width: 100%;
  padding-top: 64px;
  background: #F9F8F7;
  box-sizing: border-box;

  .details-top {
    width: 100%;
    position: fixed;
    background: #F9F8F7;
    top: 0;
    left: 0;
    z-index: 9;

    .logo-container {
      /deep/ .van-search {
        background-color: transparent;

        .van-search__content {
          border: 1px solid #F1EFED;
          background: rgba(255, 255, 255, 0.5);

          .van-field__control {
            color: #949BA5;
            font-weight: 400;
            font-size: 13px;

            &::placeholder {
              color: #949BA5;
              font-weight: 400;
              font-size: 13px;
            }
          }
        }
      }
    }

  }

  .flex-div {
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    justify-content: space-between;
    position: relative;
    background: #F9F8F7;

    .flex-item {
      background-color: #fff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      height: 36px;
      width: 49%;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 13px;
      color: #6A7481;

      .icon-up {
        width: 13px;
        display: block;
      }
    }

    .filter-fixed {
      position: absolute;
      left: 0;
      width: 100%;
      height: 380px;
      top: 46px;
      background-color: #fff;
      z-index: 99;
      padding: 23px 15px;
      box-sizing: border-box;
      box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.1);

      .filter-con {
        position: absolute;
        top: 0;
        left: 0;
        background-color: #fff;
        width: 100%;
        height: 380px;
        background-color: #fff;
        z-index: 99;
        padding: 23px 15px;
        box-sizing: border-box;
      }

      .filter-nav {
        &.mtop {
          margin-top: 18px;
        }

        .title {
          font-size: 16px;
          line-height: 22px;
          color: #333333;
          font-weight: 600;
          position: relative;
          padding-left: 16px;
          margin-bottom: 14px;

          &::before {
            position: absolute;
            width: 4px;
            height: 12px;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            background-color: #EB1700;
            border-radius: 100px;
          }
        }

        .cons {
          display: flex;
          align-content: center;
          flex-wrap: wrap;

          .cons-title {
            height: 34px;
            line-height: 34px;
            text-align: center;
            margin-right: 12px;
            margin-bottom: 12px;
            background-color: #f6f6f6;
            font-size: 12px;
            color: #333333;
            border-radius: 8px 8px 8px 8px;
            padding: 0 20px;

            &.cur {
              background-color: rgba(235, 23, 0, 0.10);
              color: #EB1700;
            }
          }
        }
      }

      .fixed-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 35px;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 16px;
        z-index: 999;

        .btn-txt {
          width: 144px;
          height: 40px;
          border-radius: 4px;
          line-height: 40px;
          text-align: center;
          font-size: 14px;

          &.cancel-btn {
            border: 1px solid #989898;
            box-sizing: border-box;
          }

          &.submit-btn {
            background-color: #EB1700;
            color: #fff;
          }
        }
      }
    }

  }

  .con-list {
    padding: 10px 16px;
    box-sizing: border-box;

    .con-item {
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      border-radius: 12px;

      .con-cover {
        min-width: 32px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
        overflow: hidden;
      }

      .con-txt {
        font-size: 14px;
        flex: 1;

        .txt-title {
          color: #000000;
          font-weight: 500;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .txt-tag {
          color: #B1B1B1;
        }
      }

      .action-btn {
        height: 32px;
        width: 83px;
        border-radius: 18px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        cursor: pointer;
        margin-left: 8px;

        &.cancel-btn {
          background: rgba(235, 23, 0, 0.08);
          color: #EB1700;
        }

        &.sign-btn {
          background: #EB1700;
          color: #FFFFFF;
        }
      }
    }
  }

  .confirm-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    font-weight: 500;
    color: #fff;
    background-color: #eb1700;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/selectActivity.vue